// @ts-ignore - imported using Rollup json plugin
export { version as npmVersion } from '../package.json';
export const compatibilityVersion = 6;
